import React from 'react'
import Title from '../layouts/Title'
import ProjectCards from './ProjectCards'

import { ora, eipca, book, ig, roi, ai } from "../../assets";




const Projects = () => {
  return (
    <section id = 'projects' className='w-full py-20 border-b-[1px] border-b-black'>
        <div className='flex justify-center items-center text-center'>
            <Title
                title = "VISIT MY PORTFOLIO"
                des= "My Projects"
            />            
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        
        <ProjectCards
          title="ORA"
          des="The platform simulating a physical therapist for patients using AI employs trigonometric functions and deep learning to detect joints. 
          It also uses neural networks for text-to-speech and integrates gamification into physical therapy for sustainable treatment."
          src={ora}
        />
        <ProjectCards
          title="EIPCA"
          des="The platform for screening cardiac abnormalities using ECG graphs applies YOLOv7 and enhances the software structure with FPN (Feature Pyramid Networks). 
          It also refines 2D CNN layers to facilitate End-to-End Learning, thereby improving accuracy in ECG graph analysis."
          src={eipca}
        />
        <ProjectCards
          title="Credit Risk and NPLs Probability Prediction Model"
          des="An Open-Source Implementation Published on Medium, Aimed at Helping Financial Institutions Leverage Advanced Techniques to Reduce Non-Performing Loans (NPLs) and Enhance Financial Stability Through Data-Driven Insights."
          src={ai}
        />
        <ProjectCards
          title="Financial & ROI Tracking Dashboard"
          des="A tool built with React.js and styled with Tailwind CSS to help users monitor financial performance and return on investment. 
          It provides real-time insights into revenue, expenses, and key metrics, enabling users to track growth, optimize strategies, and make informed decisions."
          src={roi}
        />
        <ProjectCards
          title="Who Am I : A Glitch in the Matrix. (Available on Amazon KDP)"
          des="A human-computer genre book available on Amazon Kindle, journey of reality, and AI. Story between human consciousness and technology. Additionally, 5% of each book’s income will be donated to the Friends of the Asian Elephant (FAE)’s Elephant Hospital in Lampang, Thailand."
          src={book}
        />
        <ProjectCards
          title="Bondst.cnx : Street wear resale store"
          des=" An online streetwear and authentic sneaker store based in Chiang Mai. It offers a selection of streetwear trends and premium sneakers from top global brands, along with exclusive Bondst.cnx branded products. Focused on provides a shopping experience for sneakerheads."
          src={ig}
        />
      </div>

    </section>

  )
}

export default Projects